import { getCaxaPort } from "./getCaxaPort.js";
let sequenceId = 0;
function getSequenceId() {
  return `${sequenceId++}`;
}
async function getCaxaWebSocket() {
  if (!window.globalWebSocket) {
    const port = getCaxaPort();
    const webSocketUrl = `ws://127.0.0.1:${port}`;
    const webSocket = new WebSocket(webSocketUrl);
    window.globalWebSocket = {
      webSocket,
      webSocketPromise: new Promise((resolve) => {
        webSocket.addEventListener("error", () => {
          throw new Error(`webSocket\u94FE\u63A5\u5931\u8D25\u3002webSocket url\uFF1A${webSocketUrl}\u3002`);
        });
        webSocket.addEventListener("open", () => {
          resolve(webSocket);
        });
        webSocket.addEventListener("close", () => {
          window.globalWebSocket = void 0;
        });
      })
    };
  }
  return await window.globalWebSocket.webSocketPromise;
}
function getMessageFactory(arg) {
  const { code } = arg;
  const fun = (sendParam, socketNext) => {
    const responseList = [];
    return new Promise((resolve, reject) => {
      getCaxaWebSocket().then((webSocket) => {
        const sequenceId2 = getSequenceId();
        function message(e) {
          const data = JSON.parse(e.data);
          if (data.sequenceId === sequenceId2 && data.code === code) {
            if (socketNext) {
              responseList.push(e);
              if (socketNext(responseList)) {
                resolve(responseList);
                webSocket.removeEventListener("message", message);
              }
            } else {
              if (!data.status) {
                return reject(`\u6307\u4EE4${code}\u8FD4\u56DE\u9519\u8BEF\u4FE1\u606F\u3002message\uFF1A${data.message}`);
              } else {
                resolve(data.data);
              }
              webSocket.removeEventListener("message", message);
            }
          }
        }
        webSocket.addEventListener("message", message);
        webSocket.send(JSON.stringify({
          code,
          sequenceId: sequenceId2,
          param: sendParam
        }));
      });
    });
  };
  return fun;
}
export { getCaxaWebSocket, getMessageFactory, getSequenceId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/getCaxaWebSocket.js